<template>
    <p class="text-xs-center pa-5">{{ $t('callback.logging-you-in') }}</p>
</template>

<script>
import AuthService from '@/lib/Auth';
import { Events, EventBus } from '@/lib/EventBus';
export default {
    name: 'callback',
    props: ['auth'],
    async created() {
        try {
            await AuthService.handleAuthentication();
        } catch (err) {
            EventBus.$emit(Events.ToastError, this.$t('callback.logging-you-in-error'), err);
        }

        this.$router.push({ name: 'home' });
    }
};
</script>
